import React from 'react';
import { Stack, Button } from '@kis-technologies/kis-ui';
import { SuggestionsContainer, useStyles } from '../styled';
import { SuggestionProps } from '../types';

/**
 * List of suggestions for shortcuts of words
 * e.g. Email
 */

export const Suggestions = (props: SuggestionProps) => {
  const { suggestions, onClick } = props;
  const classes = useStyles();
  if (!suggestions) return null;

  if (typeof suggestions === 'string') {
    return (
      <Button onClick={onClick} value={suggestions}>
        {suggestions}
      </Button>
    );
  }

  return (
    <>
      <SuggestionsContainer>
        <Stack>
          {suggestions.map((suggestion, idx) => {
            if (typeof suggestion === 'object') {
              return (
                <Button
                  key={idx}
                  width={373}
                  sx={{ margin: '0 30px' }}
                  customSize="large"
                  onClick={onClick}
                  value={suggestion.value}
                >
                  {suggestion.display ? suggestion.display : suggestion.value}
                </Button>
              );
            }
            return (
              <Button
                key={idx}
                customSize="large"
                onClick={onClick}
                value={suggestion}
                className={classes.suggestionButton}
              >
                {suggestion}
              </Button>
            );
          })}
        </Stack>
      </SuggestionsContainer>
    </>
  );
};
